module.exports = __webpack_public_path__ + "img/Frame 2132.8f3c779e.png";